import React from 'react';

import { InvitationWizardData } from '../../../types/invitation';

interface Step3UseCaseProps {
  wizardData: InvitationWizardData;
  errors: Record<string, string>;
  onInputChange: (field: string, value: string) => void;
}

const useCaseOptions = [
  { value: 'design urban lighting', label: 'Design urban lighting' },
  { value: 'electrical engineering', label: 'Electrical systems & calculations' },
  { value: 'architectural lighting', label: 'Architectural / Interior design' },
  { value: 'just browsing/checking out', label: 'Just browsing / checking out' },
];

export const Step3UseCase: React.FC<Step3UseCaseProps> = ({ wizardData, errors, onInputChange }) => {
  return (
    <div className="flex flex-col gap-2 md:gap-2.5">
      {useCaseOptions.map((option) => {
        const isSelected = wizardData.useCase === option.value;
        return (
          <div
            key={option.value}
            role="radio"
            aria-checked={isSelected}
            tabIndex={0}
            onClick={() => onInputChange('useCase', option.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onInputChange('useCase', option.value);
              }
            }}
            className={`
              cursor-pointer rounded-lg px-3 py-2.5 md:px-4 md:py-3 transition-all duration-200
              ${
                isSelected
                  ? 'border-2 border-green01 bg-green01/[0.06]'
                  : 'border border-white/[0.15] hover:border-white/30 hover:bg-white/[0.03]'
              }
            `}
          >
            <p className={`text-white text-xs md:text-sm ${isSelected ? 'font-semibold' : ''}`}>{option.label}</p>
          </div>
        );
      })}
      {errors.useCase && <p className="text-[#FF8A00] text-xs">{errors.useCase}</p>}
    </div>
  );
};
